import $ from 'jquery'

var setNav = function() {

  var path = window.location.pathname;
  var host = window.location.host;

   $(".menu-item a").each(function() {

    var href = this.pathname;

    if (path == href) {
      $(this).parent().addClass("active-page");
    } else {
      $(this).parent().removeClass("active-page current_page_item");
    }

  });

};


module.exports = setNav;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/setnav.js